import {OwnershipTypeForm, OwnershipTypeFormProps} from "./OwnershipTypeForm";
import {PopupForm} from "@tracabois/components";

export interface OwnershipTypeFormPopupProps extends OwnershipTypeFormProps {
  open: boolean
}

export const OwnershipTypeFormPopup = (props: OwnershipTypeFormPopupProps) => {
  const {open, ...ownershipTypeFormProps} = props
  const title = !ownershipTypeFormProps.item?.id ? "Création d'un type de propriété" : "Type de propriété"
  return (
    <PopupForm open={open} onClose={ownershipTypeFormProps.onCancel} title={title}>
      <OwnershipTypeForm
        {...ownershipTypeFormProps}
      />
    </PopupForm>
  )
};
